import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React, { ReactElement } from "react";

export interface ConfirmationDialogProps {
    title: string;
    content: string;
    onCancel: () => void;
    onConfirm: () => void;
    open?: boolean;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps): ReactElement {
    return <Dialog
        open={props.open ?? false}
        onClose={props.onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        PaperProps={{
            sx: {
                minWidth: '500px',
                '& .MuiDialogContent-root': {
                    whiteSpace: 'pre-line',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                }
            }
        }}
    >
        <DialogTitle>
            {props.title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText
                sx={{
                    whiteSpace: 'pre-line',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                }}
            >
                {props.content}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.onCancel} color="primary">
                Cancel
            </Button>
            <Button color="primary" autoFocus onClick={props.onConfirm}>
                OK
            </Button>
        </DialogActions>
    </Dialog>
}
